export default {
  /**
   * Returns the list of all users
   */
  getUsers: state => {
    // filter the accounts from locale.ai to mask god views
    return state.users && state.users.length > 0
      ? state.users.filter(item => !item.email.includes("locale.ai"))
      : [];
  },
};
